import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import PublicSectorITSupportDetails from '../../subdepartmentdetails/PublicSectorITSupport'


function PublicSectorITSupport() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Public Sector IT Support and Solutions || Innovation and Technology";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Innovation Technology"
            title="Public Sector IT Support"
            subtitledown="Department of Innovation & Technology"
           />
            <PublicSectorITSupportDetails/>
        </div>
    </>
  )
}

export default PublicSectorITSupport